/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const Tag = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 12 12" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M4.303 11.78c-.41-.408-3.65-3.656-4.059-4.065-.507-.51 0-1.017 0-1.017L6.078.85C6.561.366 7.22.215 7.22.215c.41-.058.962-.127 1.388-.178.003 0 2.29-.202 2.78.289l.287.286c.49.493.29 2.784.289 2.788-.052.427-.12.98-.179 1.39 0 0-.15.66-.634 1.144l-5.833 5.847s-.508.51-1.015 0zm5.422-9.5a1.21 1.21 0 0 0-1.713 0 1.216 1.216 0 0 0 0 1.716 1.21 1.21 0 0 0 1.713 0 1.215 1.215 0 0 0 0-1.716z" />
      </g>
    </svg>
  </span>
);

Tag.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

Tag.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default Tag;
